import { jsx as _jsx } from "react/jsx-runtime";
import { StyleSheet } from 'react-native';
import { theme } from '@xbto/design-system';
import { Surface } from '../../atoms';
import { Callout } from '../../molecules';
export function AccountFundNoHolding({ onPressCta }) {
    return (_jsx(Surface, { variant: "tertiary", style: $.container, small: true, children: _jsx(Callout, { small: true, title: "You currently have no holdings", message: "Any previous subscriptions and redemptions are visible on you statements", ctas: [
                {
                    variant: 'secondary',
                    label: 'Views statements',
                    onPress: onPressCta,
                    size: 'sm',
                    style: { width: 'auto' },
                },
            ] }) }));
}
const $ = StyleSheet.create({
    container: {
        borderWidth: 1,
        borderColor: theme.color.border.primary,
        borderRadius: theme.radius.md,
    },
});
